import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading, notificationFail, notificationSuccess } from "../slices/notificationSlice";
import { setAuthConfig, setUiIncomeLimit, setVerifyAuth } from "../slices/authSlice";
import dotnetApiClient from "../../config/dotnetApiClient";
import { handleLogout } from "../../helper/service";

// ---------- bootstrap GET call
export const getAuthConfig: any = createAsyncThunk(
  "getAuthConfig",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient(false, false).get(`/bootstrap`);

      const uiFlowJsonId = localStorage.getItem("uiFlowJsonId");

      dispatch(setLoading(false));

      if (response?.data) {
        if (uiFlowJsonId) {
          localStorage.setItem("uiFlowJsonId", uiFlowJsonId);
        }
        dispatch(setAuthConfig(response?.data));
      } else {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const getUiIncomeLimit: any = createAsyncThunk(
  "getUiIncomeLimit",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient(false, false).get(`/UiIncomeLimit`);
      dispatch(setLoading(false));

      if (response?.data) {
        dispatch(setUiIncomeLimit(response?.data));
      } else {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

// ---------- bootstrap POST call
export const getVerifyAuth: any = createAsyncThunk(
  "getVerifyAuth",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient().post(`/bootstrap`);

      if (response?.data) {
        localStorage.setItem("userType", response?.data?.userType);
        localStorage.setItem("bootstrapData", JSON.stringify(response?.data));
        localStorage.setItem("isBootstrapCalled", "true");

        dispatch(setVerifyAuth(response?.data));

        return response;
      }
      dispatch(notificationFail(response?.data?.message || "Something went wrong"));
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(notificationFail("Something went wrong"));
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const resendVerifyEmailLink: any = createAsyncThunk(
  "resendVerificationMail",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient().post(`/bootstrap/sendVerificationEmail`);

      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(
          notificationSuccess("Verification link has been sent successfully to your inbox.")
        );
        return response;
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

// ---------- bootstrap email verification GET call
export const getVerifyEmail: any = createAsyncThunk(
  "getEmailVerified",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient().get(`/bootstrap/emailVerified`);
      dispatch(setLoading(false));

      return response;
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);
